export enum ManageSavedSearchSortOrders {
    DATE_ADDED_NEWEST = 'addedNewest',
    DATE_ADDED_OLDEST = 'addedOldest',
    RESULT_COUNT = 'resultCount',
    SEARCH_TERM = 'searchTerm',
}
